import React from 'react';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import RecommendSearchWordList from '../RecommendSearchWordList';
import RecommendSearchWordListSearchBox from '../RecommendSearchWordListSearchBox';

const RecommendSearchWordListWrap = (props) => {
  const { recommendSearchWordList, setData, getList } = props;

  return (
    <div className="recommend-search-word-list-wrap">
      {/* 추천 검색 키워드 검색 박스*/}
      <RecommendSearchWordListSearchBox
        setData={(data) =>
          setData({
            path: ['recommendSearchWordList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={recommendSearchWordList.searchData}
        getList={getList}
      />

      {/* 추천 검색 키워드 리스트*/}
      <RecommendSearchWordList
        recommendSearchWordList={recommendSearchWordList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={recommendSearchWordList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RecommendSearchWordListWrap;
